import React from 'react';
import { modal } from '../../../../Base/Modal';

const ConfirmModal = ({ onSubmit, blocked }) => (
  <div className="dash-modal dash-modal--small">
    <button onClick={modal.close} className="close-modal" type="button">
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0.5 0.5L12.5 12.5M0.5 12.5L12.5 0.5" stroke="#424242" />
      </svg>
    </button>
    <div className="dash-modal__body">
      <p className="modal-title">{`${
        blocked ? (+blocked && 'Unblock') || 'Block' : 'Delete'
      } user`}</p>
      <div className="modal-text">
        <p>{`Are you sure that you want to ${
          blocked ? (+blocked && 'unblock') || 'block' : 'delete'
        } user?`}</p>
      </div>
      <div className="modal-btns">
        <button
          onClick={modal.close}
          className={`dash-btn ${
            (blocked && 'dash-btn--cancel') || 'dash-btn--type2'
          }`}
          type="button"
        >
          Cancel
        </button>
        <button
          onClick={onSubmit}
          className={`dash-btn ${blocked ? '' : 'dash-btn--delete'}`}
          type="button"
        >
          {(blocked && 'Confirm') || 'Delete'}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
